import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { isDistributor } from 'utils/distributor';
import { deleteDistributor } from 'endpoints/distributors';

export default function DeleteUserDialog({
  modalOpen,
  selectedUser,
  handleClose,
}) {
  const queryClient = useQueryClient();
  const { isLoading, refetch } = useQuery(
    'deleteDistributor',
    () => deleteDistributor(selectedUser.id), {
      manual: true,
      retry: false,
      refetchOnMount: false,
      enabled: false,
      onError: error => {
        toast.error(error.response.data.message);
      },
      onSuccess: () => {
        toast.success(t('deletedUser'));
        queryClient.refetchQueries(['users']);
        !isDistributor() && queryClient.refetchQueries(['distributors']);
        handleClose();
      },
    },
  );

  const { t } = useTranslation('form');
  return (
    <Dialog open={modalOpen} onClose={handleClose} disableBackdropClick={isLoading} disableEscapeKeyDown={isLoading}>
      <DialogTitle>{t('confirmDelete')}</DialogTitle>
      <DialogContent>
      {selectedUser?.numberOfUsers ? <DialogContentText color="error">
          {t('hasUsers', { users: selectedUser?.numberOfUsers })}
      </DialogContentText> : null}
        <DialogContentText>
          {t('confirmDeleteMessage', { name: selectedUser?.name })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading} variant="outlined" color="default">
          {t('cancel')}
        </Button>
        <Button
          onClick={refetch}
          disabled={isLoading}
          variant="outlined"
          color="primary"
          autoFocus
        >
          {t('clear')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
